<template>
  <div class="col-span-6">
    <div>
      <label for="field.label" class="block 2xl:text-sm sm:text-xl font-medium leading-5 text-gray-700">
        {{field.label}}
      </label>
    </div>
    <div class="mt-4 space-y-4">
      <template v-for="option in field.options">
        <div v-bind:key="option.id" class="flex items-center">
          <input id="option" :value="option" v-model="picked" name="push_notifications" type="radio" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
          <label for="option" class="ml-3 block 2xl:text-sm sm:text-xl font-medium text-gray-700">
            {{option}}
          </label>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'radio-field',
  data() {
    return {
      picked: ''
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
  },
  watch: {
    picked() {
      this.$parent.updateValue(this.field.key, this.picked)
    }
  }
}
</script>
